import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './ContactCard.css';


const ContactCard = ({ info }) => {
    return (
        <div className="col-md-3 mt-2">
            <div className={`justify-content-center bg-${info.background}`}>
                <img className="mt-4 px-3" src={info.icon} style={{ width: '30%' }} alt="..." />
                {/* <FontAwesomeIcon className="info-icon" icon={info.icon}></FontAwesomeIcon> */}
                <div >
                    <h5 class="card-title mt-4 px-3">{info.title}</h5>
                    <p class="card-text px-3">{info.description}</p>
                    <p class="card-text px-3">
                        <a href='https://www.linkedin.com/in/faiyadahmedsudipto/' rel="noreferrer" target="_blank">{info.accountOne}</a>
                        - <a href='https://github.com/FaiyadAhmedSudipto' rel="noreferrer" target="_blank">{info.accountTwo}</a>
                        - <a href='https://www.facebook.com/faiyadahmed.sudipto/' rel="noreferrer" target="_blank">{info.accountThree}</a>
                    </p>
                    {/* <p class="card-text px-3">{info.accountOne}</p>
                    <p class="card-text px-3">{info.accountTwo}</p>
                    <p class="card-text px-3">{info.accountThree}</p> */}
                </div>
            </div>
        </div>
    );
};

export default ContactCard;